import { gql } from '@apollo/client';
import React, { FC } from 'react';

import { EntityScoreQueryOperationQuery as EntityScoreQueryOperation } from 'core/graphql';
import { LabeledMeter } from 'shared/components/internal/LabeledMeter';
import { useQuery } from 'shared/hooks';

const DEFAULT_MAX_SCORE = 12;

export const ENTITY_SCORE_QUERY = gql`
  query EntityScoreQueryOperation {
    insightConfig {
      threshold
    }
  }
`;

interface EntityRowScoreContainerProps {
  current: number;
}

export const EntityRowScoreContainer: FC<
  React.PropsWithChildren<EntityRowScoreContainerProps>
> = ({ current }) => {
  const { data } = useQuery<EntityScoreQueryOperation>(ENTITY_SCORE_QUERY, {
    errorPolicy: 'none',
    notifyErrors: false,
  });
  const max = data?.insightConfig?.threshold || DEFAULT_MAX_SCORE;

  return <LabeledMeter current={current} max={max} />;
};
